// get product path from url
export const getPath = () => {
    let path = document.location.pathname.split('/')[2];
    return path === 'subscriptions' ? 'family-space' : path;
}
